import React, { useRef, useState } from 'react'
import {
    View,
    Text,
    KeyboardAvoidingView,
    Platform,
    TouchableOpacity,
    ScrollView,
    ActivityIndicator
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, MaterialIcons, AntDesign } from '@expo/vector-icons'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import moment from 'moment'
import Toast from 'react-native-toast-message'
import Canvas from '../../canvas'

const Wotconline = ({ navigation, route }) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        completeOnline
    } = route.params

    // const canvasRef = useRef(null)
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postwotconline } = useFormsStore()


    function getboolean(value) {
        switch (value) {
            case 0:
                return "No"
            case 1:
                return "Yes"
            default:
                return ""
        }
    }


    function getvalue(value) {
        switch (value) {
            case 0:
                return false;

            case 1:
                return true;
            default:
                return null;
        }
    }
    function getnumber(value) {
        switch (value) {
            case 0:
                return 0;

            case 1:
                return 1;
            default:
                return null;
        }
    }
    let youthemployee = getvalue(values?.youthemployee)
    let qualifiedSnap = getvalue(values?.qualifiedsnap)
    let ssiincome = getvalue(values?.ssiincome)
    let qualifiedIvarecipient = getvalue(values?.qualified4arecepient)
    let isveteranofarmed = getvalue(values?.isveteranofarmed)
    let isexfeleon = getvalue(values?.isexfeleon)
    let isworkreleaseprogram = getvalue(values?.isworkreleaseprogram)
    let vocationalrehabiltaion = getvalue(values?.vocationalrehabiltaion)
    let islongtermrecepient = getvalue(values?.islongtermrecepient)
    let isltur = getvalue(values?.isltur)
    let typeofconviction = getnumber(values?.typeofconviction)
    let communityresidence = getnumber(values?.communityresidence)
    let startingwage = values?.startingwage ? values?.startingwage : null
    const data = {
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        completeOnline: completeOnline,
        sign: signatureDataURL,
        essUserKey: intializeStore.initializeData?.userkey,
        entityId: personalstore?.personalData?.entityId,
        previousEmployee: values?.previousemployee == 0 ? false : true,
        employmentStartDate: values?.employmentstartdate ? moment(values.employmentstartdate).format("YYYY-MM-DD") : null,
        startingWage: startingwage,
        jobDesc: values?.jobtitle,
        qualifiedIvarecipient: qualifiedIvarecipient,
        pbenifitsRecipient: values?.pbenefitsrecipient,
        pbenifitsState: values?.pbenefitsstate,
        veteranOfArmed: isveteranofarmed,
        vpbenifitsRecipient: values?.vpbenefitsrecipient,
        vpbenifitsState: values?.vpbenefitsstate,
        exFelon: isexfeleon,
        felonyConvictionStartDate: values?.felonyconvictionstartdate ? moment(values.felonyconvictionstartdate).format("YYYY-MM-DD") : null,
        typeOfConviction: typeofconviction,
        releaseDate: values?.releasedate ? moment(values.releasedate).format("YYYY-MM-DD") : null,
        felonState: values.felonstate,
        workReleaseProgram: isworkreleaseprogram,
        communityResidence: communityresidence,
        vocationalRehabilation: vocationalrehabiltaion,
        youthEmployee: youthemployee,
        qualifiedSnap: qualifiedSnap,
        snapRecepient: values?.snaprecepient,
        snapState: values?.snapstate,
        ssincome: ssiincome,
        isLongtermRecepient: islongtermrecepient,
        tanfrecepient: values?.tanfrecepient,
        tanfstate: values?.tanfstate,
        isLturecepient: isltur,
        lturstate: values?.lturstate
    }
    const handlesubmit = async () => {
        const response: any = await postwotconline(data)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <KeyboardAvoidingView
                behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
                style={{ flex: 1 }}
            >
                <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                    <View style={[globalStyles.horizontalPadGap]}>
                        <TouchableOpacity
                            onPress={() => navigation.navigate('OnboardingForms')}
                            style={[
                                globalStyles.hDirection,
                                globalStyles.vCenterItems,
                                globalStyles.flexOne
                            ]}
                        >
                            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
                                <Ionicons
                                    name="chevron-back"
                                    size={24}
                                    color={colorPalette.white}
                                />
                            </View>
                            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
                                {'Forms '}
                            </Text>
                        </TouchableOpacity>
                    </View>
                    <View style={[globalStyles.vCenterItems]}>
                        <Text
                            style={[
                                globalStyles.text,
                                globalStyles.fwBold,
                                globalStyles.fs30,
                                globalStyles.whiteTextColor,
                                globalStyles.textCenter
                            ]}
                        >
                            WOTC Form Information
                        </Text>
                    </View>
                </View>
                {/* <View style={[globalStyles.containerOverlap]}> */}
                <ScrollView>
                    <Card>
                        <div
                            style={{
                                backgroundColor: '#fff',
                                padding: '20px',
                                borderRadius: '5px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.1)'
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginLeft: '10px' }}>
                                        <img
                                            width="70"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAABHVBMVEX///8FOoIAAAAFO4Xc3NysrKx+fn76+voAM35VVVX/rWL/qF//qmDCwsKRkZHMzMwjIyPt7e23t7d0dHQ9PT0AHV0PDw8AGTvm6O/x8vbU2OMAGzv/KVEAKV2SLTCgp8GaZzpkZGSOXi7zHUu7v9LHzNuwtcsALXQAI2gAADEAD1CMXDRePyPOiE0AAEOncD8AACtIR0SzeEQAABGecT2LFivUHz17EyaVnLqKkrNndqJ/iK0AADqJiISjop87OTMAACRjPQB6UjIAHk4+NEEoHRoWIj7ilU4AIVkwKjduTDp2TCIAABkAMIS8ej1jRz9lQhxLMRwvHgcAEio+UY4EMnBFKwCjDDPFFD4xCA92Ih9OYpdHMSYXGiwlICgxWCxtAAAFpElEQVRIiY1Xi3baRhAdtIIFiacIeLXGlbD1wAiQgwMWkW1aqC07aalpmuK2Sf7/MzorgS0IcTLHPgLt3p3nzlwA9omczRVexVLIZeW9W/ZIqd3Mabibxn+ylmu2S99H0bJUrgG3wbA4ZYGli5c1fElfxpWbJaAOBAy4ZetgiKMmzEIzmuUXYBVJA+7AW3BsyiBkMMGXFoMADA6aVPkWrl4AziGwHM4NrgsjGf5zrht4CJpaqO/3rqqBFeJGCz3EuF7V2+16GWOqo8Mcj9B1rbrH05ok4yoejmdrBemy0XFROt1TqV6JNUPAQZZqX+NqDsNYGJReSd08ISQjBJ/EHUjXuMO2k207dooXoRPocC011qAnIaSLwTaYANekbWurMgYfQqhNB7uwBPpzHX110CS5uhVPTIMRCh9chOXJDgq/kwYGRvhia6nYVgqYdAdYRcqQDPllNk9BSb7za+8GX7tSjQMLbSg851OiAWc6kyWxn9we9/0nKOm8i0y/I3S6EtagjUqlDa6cBfZWx4jFm8ld5EXFGe4VVt9HRW84y8cL7hR4AJxp6+qjTcoxSzB110pOPb+nLjof747yPWXozYbzdW4a6F6IldRMIlsuGbbNodzdWDePzF7UPz2P3nXeK6YZJQrFym8VHYvELiUq0WQ+san0FBBy65vm8fz3xR/uQ7Q0H55Dla+CZUzWXpbKOuZWz3WeI5l/X+zNzJvIv+nf9KP7VIgHGiJ0uyxudruGRcxSCkUYvkTLyPeHXn/md9NZFSqDwK61EdhkExv4dSO9Tu49z+yje0u/t10MZzJ1nACaWEI5dDGEaX5rvdP3lkvTay78h52FKxDFnpMhq8WX43ynQi9NL+qZvrdo7NRfUqpaVmBFhAa7pX277HumNzzdeU3O43uFdhaSXHa+Kuyzntn7847sXBYySCq1AK+S6+FuH3xw+OHW7C39+YfD+RaSdLOYD0AYAv/CA7ZD8PEoQ46Wy/f3+GW+rbGD3eDtGojyeguYT8R11x/Sa52k3PYBD/4+9o63RDr6JjBtKvmsFBVzKMQf+pGiRKmUxKamgOngkANVVfv+ECHKcNbHz2mgCE4MxHRQ7lyn0hED1WJkRv1hr6/uAON0UITlZB7YeroAyEERRX0Ymr2h76PZW8BzGjihjQWQ1bjObPk8DXzzxn+TkuO71GIVKLZmLDnEMh1oqsjJ4cnJ6rF18iTjo+c73rnCacSoKNQm6Nwyss/mkMPWxWr02Gq1xqvxiXikgGcyF0OsGV9kHG3AUp3j8GT0z2jVaq0uWq2Lx3EamJlCQCG5yNh5AttOtQ6hcTQan4wuVuPH1eMoZSoZlDgYAcStAzsPAxrWpBRwjI7F0npESWnEzoF9bd2SyxoEBuXXT+3x4Kdt+XcDJOeybYHN1+2RNsXgDPSpSzZ5VESpqVFUVIRs8ki6V8xyLA7rhixGAA8ZdtZU5Si+uZhhj0MproFiBDAbZ5r2REAkQELCDHk9PJKSM82h4hWV3qbkiNukDs5563no4JjDuRfqyZjLkMuoGJe5uVBUNULlboKr6VZIt8YcDlbs5pQ5yWDNLPuq8K7vqYpSVBen8WCdUvgP5yNoW6SlKjNGQ7DpazHKSePy7MOnY1X1e5/PLuOBh6Pcodh/d0Z5TB5CYA5AVpCHWNxPX9z1x0G1IibThPNd8iB4iG4FglcgDRwkgI+Z5IDLalbMRcGxvqIrMUESj0BHVqa1pctux80LgnQmCBIWCzcc0PcQJEHJ8FxuI+WzsHHKWjlXr19dI3HlMMGLxxgeuI+SQUwC0UvByibUchiq5th6HeSQSCSxur5BAiGhnTDRKRIhzilabSG3sZC1IuN6iXaCILoItVGHowOOTcsRdMvA5qS9SHRhQ60ZGDqENhNA9PEHqLWQDZlP5EfJ/Hr3938+/A9lHrKIa2hOBAAAAABJRU5ErkJggg=="
                                        />
                                    </div>
                                    <div style={{ marginLeft: '5px' }}>
                                        <h1 style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                            U.S. Department of Labor
                                        </h1>
                                        <h1 style={{ textAlign: 'left', fontSize: '12px' }}>
                                            Employment and Training Administration
                                        </h1>
                                    </div>
                                </div>
                                <div>
                                    <h2 style={{ textAlign: 'right', fontSize: '12px' }}>
                                        OMB Control No. 1205-0371
                                    </h2>
                                    <h2 style={{ textAlign: 'right', fontSize: '12px' }}>
                                        Expiration Date: May 31, 2026
                                    </h2>
                                </div>
                            </div>
                            <h3 style={{ textAlign: 'center', fontSize: '12px' }}>
                                Work Opportunity Tax Credit
                                <br />
                                Individual Characteristics Form (ICF)
                            </h3>

                            <table
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    fontSize: '11px'
                                }}
                            >
                                <tr>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>1. Control No. (For Agency use only)</p>
                                            {/* <p>$$ Agency Number $$</p> */}
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p style={{ textAlign: 'center' }}>
                                                SWA / AGENCY INFORMATION
                                            </p>
                                            <p style={{ textAlign: 'center' }}>
                                                (See instructions on pg 4)
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>2. Date Received (For Agency Use only)</p>
                                            {/* <p>(See instructions on pg 4) </p>  */}
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ width: '100%', border: '1px solid #000' }}>
                                    <td></td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                        EMPLOYER INFORMATION
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>3. Employer Name</p>
                                            {/* <p>$$ Agency Number $$</p>  */}
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p style={{ textAlign: 'center' }}>
                                                4. Employer Mailing Address,
                                                <br />
                                                Telephone No. and Email Address
                                            </p>
                                            <p style={{ textAlign: 'center' }}> </p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>5. Employer Identification Number (EIN)</p>
                                            <p>(See instructions on pg 4) </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ width: '100%', border: '1px solid #000' }}>
                                    <td></td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>
                                        JOB APPLICANT INFORMATION
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>6. Applicant Name (Last, First, MI)</p>

                                            <p style={{ fontWeight: "bold", fontSize: "12px" }}>{personalstore.personalData?.lastName} , {personalstore.personalData?.firstName}  {personalstore.personalData?.middleInitial}</p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p style={{ textAlign: 'center' }}>
                                                7. Social Security Number
                                            </p>
                                            <p style={{ textAlign: 'center', fontWeight: "bold", fontSize: "12px" }}>{personalstore.personalData?.ssn}</p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>Have you worked for this employer before?</p>
                                            <p style={{ fontWeight: "bold", fontSize: "12px" }}>{getboolean(values.previousemployee)}</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ width: '100%', border: '1px solid #000' }}>
                                    <td></td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>

                                        JOB APPLICANT CHARACTERISTICS FOR WOTC TARGETED GROUP(S)
                                        CERTIFICATION
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>9. Employment Start Date</p>
                                            <p style={{ fontWeight: "bold", fontSize: "12px" }}>{values?.employmentstartdate}</p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p style={{ textAlign: 'center' }}>10. Starting Wage</p>
                                            <p style={{ textAlign: 'center', fontWeight: "bold", fontSize: "12px" }}>{values?.startingwage}</p>
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            width: '33.33%',
                                            border: '1px solid #000',
                                            padding: '8px'
                                        }}
                                    >
                                        <div>
                                            <p>
                                                11. Job Position (Title) or SOC (Standard Occupation
                                                Classification)
                                            </p>
                                            <p style={{ fontWeight: "bold", fontSize: "12px" }}>{values?.jobtitle}</p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <p style={{ fontSize: '11px' }}>
                                <u>Directions</u>: Read the following statements carefully and
                                check any of following statements that apply to the job applicant.
                                Provide additional information where requested and as needed for
                                targeted group eligibility determination
                            </p>

                            <p style={{ fontSize: '11px' }}>
                                12. Qualified IV-A Recipient <br />
                                Check here if the job applicant is a Qualified IV-A Recipient
                                <span
                                    style={{
                                        marginLeft: '2px',
                                        fontSize: '11px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {getboolean(values?.qualified4arecepient)}
                                </span>
                            </p>
                            <p style={{ fontSize: '11px', borderBottom: '1px solid #000' }}>
                                If the job applicant is a member of a family receiving Temporary
                                Assistance for Needy Families (TANF), enter the name of the
                                primary benefits recipient:
                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>

                                    {values?.pbenefitsrecipient}
                                </span>
                                , and the city and state(s) where benefits:
                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                    {values?.pbenefitsstate}
                                </span>
                                were received:
                            </p>

                            <p style={{ fontSize: '12px' }}>
                                13. Qualified Veteran <br />
                                Check here if the job applicant is a veteran of the U.S. Armed
                                Forces
                                <span
                                    style={{
                                        marginLeft: '2px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {getboolean(values?.isveteranofarmed)}
                                </span>
                            </p>
                            <p style={{ fontSize: '11px', borderBottom: '1px solid #000' }}>
                                If the job applicant (veteran) is a member of a family receiving
                                Supplemental Nutrition Assistance Program (SNAP) benefits, enter
                                the name of the primary benefits recipient:
                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>

                                    {values?.vpbenefitsrecipient}
                                </span>
                                , and the city and state(s) where benefits were received:
                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>

                                    {values?.vpbenefitsstate}
                                </span>
                                . Note: Additional information may be requested to determine the
                                job applicant’s qualified veteran eligibility, such as proof of
                                being entitled to compensation for a service-connected disability
                                or having aggregate periods of unemployment
                            </p>
                            <p style={{ fontSize: '12px' }}>
                                14. Qualified Ex-Felon <br />
                                Check here if the job applicant is an Ex-Felon
                                <span
                                    style={{
                                        marginLeft: '2px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {getboolean(values.isexfeleon)}
                                </span>
                            </p>
                            <p style={{ fontSize: '12px' }}>
                                Enter date of felony conviction (mm/dd/yyyy):
                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                    {values?.felonyconvictionstartdate}
                                </span>
                                Enter date of felony conviction (mm/dd/yyyy):
                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>

                                    {values?.releasedate}
                                </span>
                            </p>
                            <p style={{ fontSize: '12px', borderBottom: '1px solid #000' }}>

                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>

                                    {values?.typeofconviction === 0 ? "Federal conviction" : values?.typeofconviction === "" ? "" : " State conviction"}
                                </span>
                                List applicable state :
                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                    {values.felonstate}
                                </span>
                            </p>

                            <p style={{ fontSize: "12px", borderBottom: "1px solid #000" }}>Check here if the job applicant is in a Work
                                Release
                                Program: <span style={{ fontWeight: "bold", fontSize: "12px" }}> {getboolean(values?.isworkreleaseprogram)}</span></p>

                            <p style={{ fontSize: "11px" }}>15. Designated Community Resident (DCR)
                                Check if the job applicant is at least age 18 but not age 40 on the hiring date, and resides in a <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}> {values?.communityresidence === 0 ? "Rural Renewal Country" : values?.communityresidence === "" ? "" : "Empowerment Zone"}</span></p>
                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>Enter job applicant’s birthday (mm/dd/yyyy): <span
                                style={{ fontWeight: "bold", fontSize: "12px" }}>{personalstore.personalData?.dateOfBirth ? moment(personalstore.personalData?.dateOfBirth).format("MM/DD/YYYY") : ""}</span>
                                <p style={{ fontSize: "11px", borderBottom: "1px solid #000", fontWeight: "bold" }}>16. Vocational Rehabilitation
                                    Referral
                                    Check here if the job applicant is a Vocational Rehabilitation (VR) Referral <span
                                        style={{ fontWeight: "bold", fontSize: "12px" }}> <span style={{ fontWeight: "bold", fontSize: "12px" }}>{
                                            getboolean(values?.vocationalrehabiltaion)}</span></span> </p>
                            </p>

                            <p style={{ fontSize: "11px" }}>17. Qualified Summer Youth Employee
                                Check here if the job applicant is a Qualified Summer Youth Employee <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}>  {getboolean(values?.youthemployee)} </span></p>
                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>Enter job applicant’s birthday (mm/dd/yyyy): <span
                                style={{ fontWeight: "bold", fontSize: "12px" }}>{personalstore.personalData?.dateOfBirth ? moment(personalstore.personalData?.dateOfBirth).format("MM/DD/YYYY") : ""}</span>

                                <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>
                                    18. Qualified Supplemental Nutrition Assistance Program (SNAP) Recipient
                                    Check here if the job applicant is a Qualified SNAP (Food Stamps) Recipient {getboolean(values?.qualifiedsnap)}
                                    Enter job applicant’s birthday (mm/dd/yyyy):<span style={{ fontWeight: "bold", fontSize: "12px" }}>{personalstore.personalData?.dateOfBirth ? moment(personalstore.personalData?.dateOfBirth).format("MM/DD/YYYY") : ""}
                                    </span>
                                    Enter the name of the primary benefits recipient: <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                                        {values?.snaprecepient}</span> and the
                                    city and state(s) where benefits were received: <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                                        {values.snapstate}</span> .
                                </p>
                            </p>

                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>19. Qualified Supplemental Security Income (SSI)
                                Recipient
                                Check here if the job applicant received or is receiving Supplemental Security Income (SSI) :<span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}>{getboolean(values?.ssiincome)}</span></p>
                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>
                                20. Long-Term Family Assistance Recipient <br />
                                Check here if the job applicant is a Long-term Family Assistance (long-term TANF) recipient <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}>{getboolean(values?.islongtermrecepient)}</span> <br />
                                Enter name of the primary benefits recipient: U ,U and the <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}>{values?.tanfrecepient}</span> <br />
                                city and state(s) where benefits were received: <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                                    {values?.tanfstate}</span> .

                            </p>
                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>21. Qualified Long-Term Unemployment Recipient
                                <br />
                                Check here if the job applicant is a qualified long-term unemployment recipient (LTUR) <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}><ul>{getboolean(values?.isltur)}</ul> </span> <br />
                                Enter city and state(s) where UI claim records / UI wage records were filed: <span
                                    style={{ fontWeight: "bold", fontSize: "12px" }}>{values?.lturstate}</span></p>

                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>22. Sources used to document eligibility. List
                                all
                                supporting documentation submitted to SWA. Indicate next to each
                                document listed whether it is attached (A) or forthcoming (F). SWA Staff: List all supporting
                                documentation
                                used in
                                determining targeted group eligibility for the applicant. Enter your initials and date when the
                                determination was made.</p>

                            <p style={{ fontSize: "11px" }}> I certify that this information is true and correct to the best of my
                                knowledge. I
                                understand that the information
                                above may be subject to verification.</p>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tr>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px" }}>23(a). Signature: (See instructions
                                        in
                                        Box 23.(b) for who signs
                                        this signature block) </td>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px" }}>23.(b) Indicate who signed
                                        this form: </td>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px" }}>24. Signature Date: </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px", height: "100px" }} >
                                        <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} /></td>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px", height: "100px" }}><span style={{ fontWeight: "bold", fontSize: "12px" }}></span></td>
                                    <td style={{ width: "33.33%", border: "1px solid #000", fontSize: "11px", height: "100px" }}><span
                                        style={{ fontWeight: "bold", fontSize: "12px" }}>{moment().format("MM/DD/YYYY")}</span></td>
                                </tr>
                            </table>
                            <p style={{ fontSize: "11px", textAlign: "justify", borderBottom: "1px solid #000" }}>
                                <span style={{ fontWeight: "bold" }}>
                                    INSTRUCTIONS FOR COMPLETING THE INDIVIDUAL CHARACTERISTICS FORM (ICF), ETA 9061. </span> This form
                                must
                                be used together with
                                IRS Form 8850 to help state workforce agencies (SWAs) determine eligibility for the Work Opportunity Tax
                                Credit (WOTC). The form may be
                                completed, on behalf of the job applicant, by: 1) the employer or employer’s representative, 2) the
                                applicant directly (if a minor, the parent or
                                guardian must sign the form), or 3) a participating agency, and signed by the individual completing the
                                form. This form is required to be used,
                                without modification, by all employers (or their representatives) seeking WOTC certification.
                                Eligibility
                                requirements for each 31TUtargeted
                                group is available on the IRS.gov websiteU31T. Additionally, information on how to submit certification
                                requests, including WOTC
                                Processing Forms. <br />
                                Box 1 and 2. State Workforce Agency (SWA) or Participating Agency. For agency use only.<br />
                                Box 3 - 5. EmployerInformation.Enter the name, address including ZIP code, telephone number, and
                                employer
                                identification
                                number (EIN) of the employer requesting WOTC certification. Note: The EIN number must be a
                                tax-identification
                                number that is registered with the state (where the business is located), so the SWA can establish an
                                employer-employee relationship where wages are paid (and federal taxes deducted). Do not enter
                                information
                                pertaining to the employer’s representative, if any. <br />
                                Box 6 - 11. Applicant Information. Enter the applicant’s full name and social security number as they
                                appear
                                on the applicant’s
                                social security card. For job title (position), enter the job applicant’s job title or the corresponding
                                standard
                                occupation classification (SOC). In Box 8, indicate whether the job applicant previously worked for the
                                employer.
                                This information will help the SWA to determine if the job applicant is a first-time, qualifying member
                                of a
                                WOTC
                                targeted group(s). For additional information about non-qualifying rehires see 26 U.S.C. §51(i)(2).<br />
                                Box 12 - 21. Applicant Characteristics. Read statements carefully, check any boxes that apply, and
                                provide
                                additional information
                                where requested. Eligibility requirements for each targeted group is available on the IRS.gov website.
                                <br />
                                Box 22. Sources to Document Eligibility. Employers and SWAs use this box to list the sources used to
                                verify
                                target groupeligibility.
                                Indicatein parentheses next to each documentlisted whetherit is attached(A) orforthcoming(F). SWAs
                                should
                                follow this
                                notation withtheirinitials andthedatetheeligibility determinationwascompleted Someexamples of acceptable
                                documentation are providedbelow.
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                Examples of Documentary Evidence and Collateral Contacts. Employers: You may check with your SWA to find
                                out what other sources you can use to verify targeted group eligibility. (You are encouraged to provide
                                copies of
                                documentation for each checked box). <br />
                                QUESTIONS 12, 18 & 20 <br />
                                <ul style={{ fontSize: "11px" }}>
                                    <li>TANF/SNAP (Food Stamp) Benefit History or Case Number Identifier</li>
                                    <li>Signed statement from Authorized Individual with a specific description of the months benefits that
                                        were
                                        received.</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTION 13  <br />
                                <ul style={{ fontSize: "11px" }}>
                                    <li>DD-214 or Discharge Papers</li>
                                    <li> Reserve Unit Contacts</li>
                                    <li> Letter of Separation or other agency documents issued only by the Department of Veterans Affairs
                                        (DVA)
                                        on DVA Letterhead
                                        certifying the Veteran has a service-connected disability and signed by the individual who verified
                                        this
                                        information.</li>
                                    <li> UI Claims Records or UI Wage Records (for unemployed veteran sub-categories)</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTION 14  <br />
                                <ul style={{ fontSize: "11px" }}>
                                    <li>Parole Officer’s Name or Statement</li>
                                    <li> Correction Institution Records</li>
                                    <li> Court Records Extracts</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTIONS 15 & 17  <br />
                                <ul style={{ fontSize: "11px" }}>
                                    <li>
                                        Birth Certificate or Copy of Hospital Record</li>
                                    <li> Driver’s License</li>
                                    <li>School I.D. Card1 </li>
                                    <li> Work Permit1</li>
                                    <li>Federal/State/Local Gov’t I.D.</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                To determine if a Designated Community Resident lives in a Rural Renewal County, visit the US Postal
                                Service
                                website:
                                www.usps.com. Click on Find Zip Code; Enter & Submit Address/Zip Code; Click on Mailing Industry
                                Information; Download and
                                Print the Information, then compare the county of the address to the list in the Instructions to IRS
                                8850
                                Form. For additional
                                information, see the Instructions for the IRS Form 8850 and the Empowerment Zone (EZ) Locator Tool,
                                available on the dol.gov
                                website.
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTION 16
                                <ul style={{ fontSize: "11px" }}>
                                    <li> Vocational Rehabilitation Agency Contact</li>
                                    <li> Veterans Administration for Disabled Veterans </li>
                                    <li> Signed letter of separation or related document from authorized Individual on DVA letterhead or
                                        agency
                                        stamp with specific
                                        description of months benefits were received.</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTION 19
                                <ul style={{ fontSize: "11px" }}>
                                    <li>
                                        SSI Record or Authorization / Evidence of SSI Benefits</li>
                                    <li> SSI Contact</li>
                                    <li>For SWAs: To determine eligibility for SSI and/or TTW Ticket Holders, send verification requests to
                                        the
                                        USDOL designated agency
                                        contact.</li>
                                </ul>

                            </p>
                            <p style={{ fontSize: "11px" }}>
                                QUESTION 21
                                <ul style={{ fontSize: "11px" }}>
                                    <li>Unemployment Insurance (UI) Wage Records</li>
                                    <li> UI Claims Records</li>
                                    <li>Self-Attestation Form, ETA Form 9175</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                BOX 22  <br />
                                <ul style={{ fontSize: "11px" }}>
                                    <li>List all sources used and provided to the SWA to document targeted group eligibility. SWA Staff:
                                        List
                                        all documentation used to
                                        determine/verify eligibility in the targeted group(s) requested by the employer/representative, to
                                        reach
                                        the final determination</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                Note:
                                1. Where a Federal/State/Local Gov’t., School I.D. Card, or Work Permit does not contain age or birth
                                date,
                                another valid document must be
                                obtained to verify an individual’s age.  <br />
                                2. ESPL No. 05-98, dated 3/18/98, officially rescinded the authority to use Form I-9 as proof of age and
                                residence. Therefore, the I-9 is no longer
                                a valid piece of documentary evidence.  <br />
                                Box 23 (a). Signature. The person who completes the form signs the signature block.  <br />
                                Box 23 (b). SignatureOptions.(a) Employer or their Authorized Representative,(b) SWA staff, (c)
                                ParticipatingAgency staff, or (d) Applicant(If applicant is minor,
                                the parent or guardian must sign).  <br />
                                Box 24. Date. Enterthemonth,dayandyearwhentheformwascompleted.  <br />
                            </p>
                            <p style={{ fontSize: "11px" }}>
                                Note: An employer’s authorized representative can be verified through an executed Employer
                                Representative
                                Authorization Form (ETA Form 9198).
                                The representative is able to facilitate WOTC activities, which includes but is not limited to:
                                <ul style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>
                                    <li> Completing, signing and submitting WOTC processing forms;</li>
                                    <li> Requesting status application updates;</li>
                                    <li> Providing clarifying information, including supporting documentation;</li>
                                    <li> Receiving copies of notices and communications; and</li>
                                    <li> Submitting employer appeals.</li>
                                </ul>
                            </p>
                            <p style={{ fontSize: "11px", borderBottom: "1px solid #000" }}>
                                Persons are not required to respondto this collection of information unless it displays a currently
                                valid OMB Control Number. Respondent’s obligation to reply to these
                                questions is required to obtain and retain benefits per law 104-188. Public reporting burden for this
                                collection of information is estimated to average 20 minutes per
                                response including the time for reading instructions, searching existing data sources, gathering and
                                maintaining the data needed, and completing and reviewing the
                                information.Send comments regarding this burden estimate or any other aspect of this collection of
                                information,including suggestions for reducing burden to the U.S.
                                Departmentof Labor,Employment and TrainingAdministration,Division of NationalPrograms,Tools, and
                                TechnicalAssistance,200 ConstitutionAve., NW,
                                Room C-4510, Washington, D.C. 20210 (Paperwork Reduction Project Control No. 1205-0371).
                            </p>

                            <p style={{ fontSize: "11px", textAlign: "justify" }}>
                                ………………………………………………………………………………………………………………………………………………………………………………</p>
                            <p style={{ fontSize: "11px", textAlign: "center" }}> (Cut along dotted line and keep in your files)</p>

                            <h1 style={{ fontSize: "11px" }}>
                                TO: THE JOB APPLICANT OR EMPLOYEE,
                            </h1>
                            <p style={{ fontSize: "11px", textAlign: "justify" }}>
                                Privacy Act Statement: The Internal Revenue Code of 1986, Section 51, as amended and its enacting
                                legislation, P.L. 104-188, specify that the State Workforce Agencies are the "designated" agencies
                                responsible for administering the WOTC certification procedures of this program. The information you
                                have
                                provided completing this form will be disclosed by your employer to the State Workforce Agency.
                                Provision
                                of this information is voluntary. However, the information is required for your employer to receive the
                                federal tax credit. IF THE INFORMATION YOU PROVIDE IS ABOUT A MEMBER OF YOUR FAMILY,
                                YOU SHOULD PROVIDE HIM/HER A COPY OF THIS NOTICE.
                            </p>
                        </div>


                        {loading ? <ActivityIndicator /> :

                            <View
                                style={{
                                    marginTop: 10,
                                    marginBottom: 25,
                                    flexDirection: 'row',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <CustomButton
                                    text={'Previous'}
                                    color={'warn'}
                                    onPress={() =>
                                        navigation.navigate('WotcInformationForm', {
                                            essUserOnBoardingFormKey,
                                            essUserOnBoardingKey
                                        })
                                    }
                                />
                                <CustomButton
                                    isDisabled={!signatureDataURL || !hasDrawn}
                                    text={'Submit'}
                                    onPress={handlesubmit}
                                />
                            </View>}
                    </Card>
                </ScrollView>
            </KeyboardAvoidingView>

        </>
    )
}
export default Wotconline
